import React, {useRef} from "react";
import {StaticImage} from "gatsby-plugin-image";
import ArrowLink from "../global/arrow-link";
import CircleButton from "../global/circle-button";

const StaticHero = () => {
  const staticHeroRef = useRef();

  const handleCircleButtonClick = () => {
    window.scrollTo({
      top: staticHeroRef.current?.getBoundingClientRect().height,
      left: 0,
      behavior: 'smooth'
    });
  }

  return (
    <section className="static-hero" ref={staticHeroRef}>
      <div className="static-hero__main-container">
        <div className="static-hero__media-container">
            <StaticImage
              className="static-hero__image"
              src="../../images/screen-1.jpg"
              alt="EVO"
              quality="60"
              layout="fullWidth"
            />
        </div>
        <div className="static-hero__content-container">
          <div className="static-hero__title-wrapper">
            <div className="static-hero__pre-title">Welcome to</div>
            <h1 className="static-hero__title">Campus Salt lake</h1>
          </div>
          <div className="static-hero__description-wrapper">
            <p className="static-hero__description">an evo x Lake Union Partners project</p>
          </div>
          <div className="static-hero__link-wrapper">
            <ArrowLink
              to="/the-vision/"
              text="The Vision"
            />
          </div>
          <div className="static-hero__scroll-button-wrapper">
            <CircleButton
              title="Scroll to view gallery and see stories"
              direction="down"
              onClick={handleCircleButtonClick}
            />
          </div>
        </div>
      </div>
      <div className="static-hero__mobile-button-container">
        <CircleButton
          title="Scroll to view gallery and see stories"
          direction="down"
          onClick={handleCircleButtonClick}
        />
      </div>
    </section>
  )
}

export default StaticHero
